export const formatDateToDDMMYYYY = (input: string): string => {
    const [month, day, year] = input.split('/');
    return `${day}.${month}.${year}`;
};